import {createContext} from 'react';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';

const defaultBack = {
    label: 'Back',
    icon: KeyboardArrowLeft,
    color: 'primary',
    testHook: 'form-nav-back',
    disabled: false,
    beforeOnClick: () => true,
    onClick: () => true,
};

const defaultNext = {
    label: 'Next',
    icon: KeyboardArrowRight,
    color: 'primary',
    testHook: 'form-nav-next',
    disabled: false,
    beforeOnClick: () => true,
    onClick: () => true,
};

const FormNavigation = createContext({
    back: defaultBack,
    next: defaultNext,
    setBackButton: () => {},
    setNextButton: () => {},
    triggerPost: false,
    setTriggerPost: () => {},
});
FormNavigation.displayName = 'FormNavigation';

export default FormNavigation;
export {defaultBack, defaultNext};
